var path = require('path')

module.exports = {
  auth0ClientDomain: "onestore.auth0.com",
  auth0EmailScope: "https://api.onestore.io/email",
  auth0LogoutURL: 'https://onestore.auth0.com/v2/logout',

  authenticationPopupWindowName: '.onestore-popup-auth',
  CreateTokenPopupWindowName: '.onestore-popup-create-token',
  LogoutPopupWindowName: 'onestore-popup-logout',

  pollTokenRequestStatusTimeoutSeconds: 3 * 60, //matches with the API
  pollTokenRequestStatusIntervalSeconds: 2,
  refreshAuthenticationStatusIntervalSeconds: 1,

  token_expiration_min_seconds : 5*60, // 5 minutes
  token_expiration_max_seconds : 100*24*60*60 // 100 days
}


//////////////////
// WEBPACK FOOTER
// ../config/common.js
// module id = avbc
// module chunks = 1